import React, { createContext, useContext, useState } from 'react';

// Creating a context for the cart
const CartContext = createContext();

// Cart Provider to wrap the app and provide the context
export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  console.log('Cart State:', cart);

  // Function to add an item to the cart
  const addToCart = (item,category) => {
    console.log('Adding item:', item,  ); // Debugging added item
  
    setCart((prevCart) => {
      // Check if the item with the same ownerId already exists in the cart
      const existingItem = prevCart.find(
        (cartItem) =>
          cartItem.itemName === item.itemName
      );
  
      // If the item exists, update the quantity
      if (existingItem) {
        console.log(`Item ${item.itemName} already in cart, increasing quantity.`);
        return prevCart.map((cartItem) =>
          cartItem.itemName === item.itemName &&
          cartItem.itemImg === item.itemImg &&
          cartItem.ownerId === item.ownerId &&
          cartItem.category === category
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      }
  
      // If the item doesn't exist, add it to the cart with quantity 1
      console.log(`Item ${item.itemName} added to cart with ownerId: ${item.owner} and category: ${category}.`);
      return [
        ...prevCart,
        { ...item, quantity: 1,category },
      ];
    });
  };
  

  // Function to remove an item from the cart
  const removeFromCart = (itemId, ownerId, category) => {
    setCart((prevCart) => {
      // Find the existing item in the cart
      const existingItem = prevCart.find(
        (cartItem) =>
          cartItem._id === itemId &&
          cartItem.ownerId === ownerId &&
          cartItem.category === category
      );

      // If the item exists and quantity is greater than 1, decrease the quantity
      if (existingItem && existingItem.quantity > 1) {
        console.log(`Decreasing quantity of item ${itemId}.`);
        return prevCart.map((cartItem) =>
          cartItem._id === itemId &&
          cartItem.ownerId === ownerId &&
          cartItem.category === category
            ? { ...cartItem, quantity: cartItem.quantity - 1 }
            : cartItem
        );
      }

      // If quantity is 1 or less, remove the item from the cart
      console.log(`Removing item ${itemId} from cart.`);
      return prevCart.filter(
        (cartItem) =>
          !(
            cartItem._id === itemId &&
            cartItem.ownerId === ownerId &&
            cartItem.category === category
          )
      );
    });
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart }}>
      {children}
    </CartContext.Provider>
  );
};

// Custom hook to use the CartContext
export const useCart = () => useContext(CartContext);
